var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block wp-10 copy-element" },
    [
      _c(
        "el-tooltip",
        {
          attrs: {
            content: _vm.tooltipMsg,
            placement: "top",
            disabled: _vm.hasPermission || _vm.data.status === "ok"
          }
        },
        [
          _c(
            "a",
            {
              staticClass: "gray-100 block",
              attrs: {
                href: _vm.hasPermission ? _vm.urlFormatted() : null,
                target: "_blank"
              }
            },
            [
              _vm.isBlockedOrDeleted(_vm.data)
                ? _c("div", { staticClass: "flex-level" }, [
                    _vm.displayIconBlockedOrDeleted
                      ? _c(
                          "div",
                          {
                            class: [
                              "avatar mr-1",
                              _vm.errorsData[_vm.data.status].class
                            ]
                          },
                          [
                            _c("i", {
                              staticClass: "block",
                              class: _vm.errorsData[_vm.data.status].icon,
                              staticStyle: {
                                "line-height": "initial",
                                width: "32px"
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "strike ellipsis avatar-name" }, [
                      _vm._v(_vm._s(_vm.fullname))
                    ])
                  ])
                : _c(
                    "div",
                    { staticClass: "flex-level" },
                    [
                      _vm.displayAvatar
                        ? _c("avatar-randomized", {
                            staticClass: "mr-1",
                            attrs: {
                              firstname: _vm.firstname,
                              lastname: _vm.lastname,
                              avatarImage:
                                _vm.data.avatar &&
                                _vm.data.avatar.type !== "initials"
                                  ? _vm.data.avatar.value
                                  : null,
                              size: _vm.size
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            _vm.statusClass(_vm.data),
                            _vm.hasHoveredActions ? "avatar-name-hovered" : "",
                            _vm.wrapText ? "ellipsis avatar-name" : ""
                          ]
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.fullname) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._t("label")
                    ],
                    2
                  )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.hasHoveredActions
        ? _c("hovered-actions", {
            attrs: { actions: _vm.actions },
            on: {
              "email-clicked": _vm.emailClicked,
              "phone-clicked": _vm.phoneClicked
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }